import React from 'react';
import PropTypes from 'prop-types';
// Models
import mCarpark from 'models/cpm/carpark';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import { listFeatureSearchFieldShape, listFilterShape } from 'constants/PropTypesShapes';
// Components
import FiltersCardTemplate from 'components/templates/FiltersCardTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import TextFieldFilter from 'components/filters/TextFieldFilter';
import CountryFieldSelector from 'components/inputFields/CountryFieldSelector';

const CarparkFilters = ({
  disabled, advanced, nbFiltersApplied, searchFields, field, filters,
  isFieldDisplayable, onFieldChange, onFilterFieldChange, onReinit, onSwitch,
}) => {
  const {
    name, address, country,
  } = filters;

  return (
    <div className="mb-3">
      <FiltersCardTemplate
        disabled={disabled}
        advanced={advanced}
        nbFiltersApplied={nbFiltersApplied}
        onReinit={onReinit}
        onSwitch={onSwitch}
        defaultBackground={false}
      >
        <React.Fragment>
          {!advanced && (
          <div className="col-12 col-md-4 col-xl-3">
            <BaseListFilter
              field={field}
              searchFields={searchFields}
              onChange={onFieldChange}
            />
          </div>
          )}
          {isFieldDisplayable('name') && (
            <div className="col-12 col-md-4 col-xl-3">
              <TextFieldFilter
                label="field.name"
                value={name.value}
                onChange={(value) => onFilterFieldChange('name', value)}
              />
            </div>
          )}
          {isFieldDisplayable('address') && (
            <div className="col-12 col-md-4 col-xl-3">
              <TextFieldFilter
                label="field.addressZipcodeCity"
                value={address.value}
                onChange={(value) => onFilterFieldChange('address', value)}
              />
            </div>
          )}
          {isFieldDisplayable('country') && (
            <div className="col-12 col-md-4 col-xl-3">
              <CountryFieldSelector
                countriesScope="all"
                value={country.value}
                onChange={(value) => onFilterFieldChange('country', value)}
              />
            </div>
          )}
        </React.Fragment>
      </FiltersCardTemplate>
    </div>
  );
};

CarparkFilters.propTypes = {
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    address: listFilterShape,
    country: listFilterShape,
    name: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters(
  mCarpark.listFeatures.searchFields,
)(CarparkFilters);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/main/CarparkFilters.js